import React, { Fragment } from 'react';
import { Collapsible, DataTable } from '@contently/toolkit';
import { renderPluralized, renderStoriesByTagType } from './csv_helpers';

import PreviewTableWrapper from './preview_table_wrapper';

const PreviewCsv = (props) => {
  const { parsedCsvData } = props;
  const {
    totalTagsToAdd,
    totalExistingTags,
    totalinvalidTags,
    validStories,
    unfoundStories,
    invalidTagGroupNames
  } = parsedCsvData;

  return (
    <div style={{ marginBottom: '14px' }}>
      <Collapsible
        collapsedText={(
          <span className="subtext">
            {`${renderPluralized('tag group', invalidTagGroupNames.length)} not found`}
          </span>
        )}
        header="Tag Groups not found(Probably not available for this publication)"
        wrapperClassName="row"
        collapsed
      >
        <ul>
          {invalidTagGroupNames.map(tagGroup => (
            <li key={tagGroup}>{tagGroup}</li>
          ))
          }
        </ul>
      </Collapsible>
      <Collapsible
        collapsedText={(
          <span className="subtext">
            {`${renderPluralized('story', unfoundStories.length)} not found`}
          </span>
        )}
        header="Stories not found"
        wrapperClassName="row"
        collapsed
      >
        <DataTable.Table
          data={unfoundStories}
          columns={[{
            Header: 'Id',
            accessor: 'storyId',
            width: 200
          },
          {
            Header: 'Title',
            accessor: 'storyTitle'
          }
          ]}
        />
      </Collapsible>
      <Collapsible
        collapsedText={(
          <Fragment>
            <span className="subtext">
              {`${renderPluralized('tag', totalTagsToAdd)} will be added to ${renderStoriesByTagType(validStories, 'tagsToAdd')}`}
            </span>
            <br />
            <span className="subtext">
              {`${renderPluralized('tag', totalExistingTags)} already found on ${renderStoriesByTagType(validStories, 'existingTags')}`}
            </span>
            <br />
            <span className="subtext">
              {`${renderPluralized('tag', totalinvalidTags)} invalid on ${renderStoriesByTagType(validStories, 'invalidTags')}`}
            </span>
          </Fragment>
        )}
        header="Valid stories"
        wrapperClassName="row"
        collapsed
      >
        <PreviewTableWrapper
          csvData={parsedCsvData.validStories}
        />
      </Collapsible>
    </div>
  );
};

export default PreviewCsv;



// WEBPACK FOOTER //
// ./app/javascript/app/components/admin2/bulk_story_tagging/preview_csv.jsx